import { getPinValidationError } from "../../lib/PinValidator.js";

export function hasValidLoginDetails({ customerNumber, user, password }) {
    return /^[0-9]{7}$/.test(customerNumber) && typeof user === "string" && user.trim().length > 0 &&
        typeof password === "string" && password.length > 0;
}

export function canSubmitAuth(form) {
    if (form.mode === "pin") return !getPinValidationError(form.pin, false);
    if (!hasValidLoginDetails(form)) return false;
    return !form.remember || (!getPinValidationError(form.pin) && form.pin === form.confirmPin);
}
